var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.797,
    height: 11.811,
    viewBox: "0 0 11.797 11.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insta_share",
    transform: "translate(-6.021 -5.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59997",
    "data-name": "Path 59997",
    d: "M17.682,6.141a.492.492,0,0,0-.517-.113L6.34,9.965a.492.492,0,0,0,0,.92l4.724,1.89,1.89,4.724a.475.475,0,0,0,.9-.015L17.785,6.658A.492.492,0,0,0,17.682,6.141Zm-4.286,9.8-1.373-3.445,2.357-2.357-.694-.694L11.309,11.82,7.885,10.427l8.626-3.115Z",
    transform: "translate(0 0)",
    fill: "#2d3e5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaShare);
export default __webpack_public_path__ + "static/media/insta_share.22c7309eaaee65f14cb0fd121d4e2919.svg";
export { ForwardRef as ReactComponent };